<template>
  <ToastModal
    ref="modal"
    show-mobile-footer
    modal-id="LoginModal"
    prevent-close
  >
    <div v-loading="loading">
      <p class="text-center mt-5 mb-4 o-heading-3" v-text="$t('ExploreMemberships.LoginToSeeDeals')" />
      <LoginForm
        ref="realLoginForm"
        :country="country"
        :loading="loading"
        @login="login"
      />
    </div>
  </ToastModal>
</template>

<script>
import ToastModal from '@/components/ToastModal'
import LoginForm from '@/components/Forms/LoginForm'
import { CountryCodes } from '@/enums/general'

export default {
  name: 'LoginModal',
  components: {
    ToastModal,
    LoginForm
  },
  props: {
    country: {
      type: String,
      default: CountryCodes.netherlands
    }
  },
  data () {
    return {
      loading: false,
      success: false
    }
  },
  methods: {
    toggleActivation (isOpen = true) {
      this.$refs.modal.toggleActivation(isOpen)
    },
    onModalClose () {
      this.$refs.modal.onModalClose()
    },
    async login (form) {
      try {
        this.loading = true
        await this.$auth.login({ ...form, disableRedirect: true })

        this.$otoaster.success(this.$t('LoginForm.LoginSuccessful'))

        this.success = true

        this.$emit('success')
      } catch (error) {
        this.$ota.general.logError(error)

        try {
          const message = JSON.parse(error?.request?.response)?.message

          if (message === 'User is not activated for login') {
            this.$otoaster.danger(this.$t('LoginForm.LoginFailedNotVerified'))
          } else if (message.includes('Too many failed login attempts')) {
            const extractMinutes = (string) => {
              const minutes = string.match(/\d+/)[0]
              return minutes
            }

            this.$otoaster.danger(this.$t('LoginForm.TooManyFailedLoginAttempts', { minutes: extractMinutes(message) }))
          } else {
            this.$otoaster.danger(this.$t('LoginForm.LoginFailed'))
          }
        } catch (error) {
          this.$otoaster.danger(this.$t('LoginForm.LoginFailed'))
        }
      } finally {
        if (!this.success) {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style scoped lang="postcss">
.ota-login-form {
  @apply p-0 px-4;

  >>> .ota-login-form-title {
    @apply hidden;
  }

  >>> .ota-login-form-button {
    @apply w-full py-10 !important;

    button {
      @apply w-full bg-yellow-400 text-neutral-800;

      &:hover {
        @apply bg-yellow-600;
      }
    }
  }
}

@screen lg {
 .ota-login-form {
  @apply px-0;
 }
}
</style>
